import { RATE_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const addRate = rate => {
  return myFetch(`${RATE_ENDPOINT}`, "POST", rate);
};
